module.exports = __webpack_public_path__ + "img/description4.850435e6.jpg";